import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-iqac-strategic-plan',
  templateUrl: './iqac-strategic-plan.component.html',
  styleUrls: ['./iqac-strategic-plan.component.scss']
})
export class IqacStrategicPlanComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
